import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { ProcesamientoDeComisionesService } from '../../services/procesamiento-de-comisiones.service';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { AltaDeVendedoresService } from '../../services/alta-de-vendedores.service';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';
import Swal from 'sweetalert2';
import { ProcesamientoDeComisionesFondoVehicularService } from '../../services/procesamiento-de-comisiones-fondo-vehicular.service';

@Component({
  selector: 'app-procesamiento-de-comisiones-fondo-vehicular',
  templateUrl: './procesamiento-de-comisiones-fondo-vehicular.component.html',
  styleUrls: ['./procesamiento-de-comisiones-fondo-vehicular.component.css']
})
export class ProcesamientoDeComisionesFondoVehicularComponent implements OnInit {

  imprimirCapturaEntradaLoading = true;
  tituloCard: string = 'Procesamiento De Comisiones Fondo Vehicular';
  tituloForm: string = 'Lista De Procesamiento De Comisiones Fondo Vehicular';

  estados: FormGroup;
  formulario: FormGroup;
  listFiltroTabla: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  date = new Date();
  y = this.date.getFullYear()
  m = (this.date.getMonth() + 1).toString().padStart(2, '0');
  firstDay = this.y + "-" + this.m + "-" + "01";
  lastDay = this.y + "-" + this.m + "-" + "31";

  fechaInicioError = false;
  fechaFinError = false;

  cmbEstados: any[] = [
    {
      clave: 'ACTIVO',
      valor: 'ACTIVO'
    },
    {
      clave: 'INACTIVO',
      valor: 'INACTIVO'
    },
  ];

  unidadesDeNegocio: any;

  listTipoFiltroTabla: any[] = [
    {
      clave: '',
      valor: 'Todos'
    },
    {
      clave: '1',
      valor: 'Procesadas'
    },
    {
      clave: '0',
      valor: 'Errores'
    },
  ];

  listEstados: any[] = [
    {
      clave: '',
      valor: 'TODOS'
    },
    {
      clave: 1,
      valor: 'ACTIVOS'
    },
    {
      clave: 0,
      valor: 'INACTIVOS'
    },
  ];

  cmbMeses: { clave: number; valor: string; }[];
  lsDetalle;

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _catalogo: CatalogoIndicadoresService,
    private _altaDeVendedor: AltaDeVendedoresService,
    private _serviciosCRUD: ProcesamientoDeComisionesFondoVehicularService,
    private _tipoDeVendedor: TipoDeVendedorService,
  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    // console.log(this.firstDay)
    // console.log(this.lastDay)

    this.formulario = this.fb.group({
      idLiquidacion: ['', [Validators.required]],
      tipoLiquidacion: ['VEHICULAR', []],
      tipoDeLiquidacion: ['VEHICULAR', []],
      anio: ['', []],
      mes: ['', []],
      mesFin: ['', []],
      tipoVendedorId: ['', [Validators.required]],
      lsTipoVendedorId: ['', [Validators.required]],
      vendedorId: ['', []],
      totalTipoLiquida: ['', []],
      totalEmplLiquida: ['', []],
      totalPagoLiquida: ['', []],
      estadoProceso: ['', []],
      estadoCierre: ['', []],
      estado: ['', []],
      usuario: ['', []],
      fechaProceso: ['', []],
      fechaRevision: ['', []],
      mesDescripcion: ['', []],
      mesFinDescripcion: ['', []],
      motivoRevision: ['', []],
      tipoVendedorDescripcion: ['', []],
      nombreVendedor: ['', []],
      sueldoVariable: ['', []],
      excepcionSueldo: ['', []],
      fechaInicio: [null, []],
      fechaFin: [null, []],
      lsUnidadNegocio: ['', []],
    });

    this.listFiltroTabla = this.fb.group({
      listTipoFiltroTabla: ['', [Validators.required]],
    });

    this.estados = this.fb.group({
      estados: [null, []],
    });

    this.listFiltroTabla.get('listTipoFiltroTabla').valueChanges
      .subscribe((resp) => {

        this.loading = true;

        if (resp == '') {
          this.lsDetalle = this.liquidacion.detalle;
          this.loading = false;
        }
        else {
          this._serviciosCRUD.filtroDetalle(resp, this.liquidacion).subscribe((res: any) => {
            this.loading = false;
            this.lsDetalle = res.detalle;
          }, (err) => {
            this.loading = false;
            this.lsDetalle = [];
          });
        }
      });

    this.estados.get('estados').valueChanges
      .subscribe((resp) => {
        this._serviciosCRUD.filtroEstado(resp).subscribe((res: any[]) => {
          // console.log("getTodo()", res)
          this.loading = false;
          this.listaVacia = (res.length === 0) ? true : false;
          this.rowData = res;
        }, (err) => {
          this.loading = false;
          this.listaVacia = true;
          this.rowData = [];
        });
      });

    this.formulario.get('tipoVendedorId').valueChanges
      .subscribe((resp) => {
        if (resp) {
          this.vendedores(resp)
        }
        this.getFormValidationErrors();
      });

    this.formulario.get('fechaInicio').valueChanges
      .subscribe((resp) => {
        // console.log("FECHA INICIO", resp)
        if (resp < this.firstDay) {
          this.fechaInicioError = true;
        }
        else {
          this.fechaInicioError = false;
        }
      });

    this.formulario.get('fechaFin').valueChanges
      .subscribe((resp) => {
        // console.log("FECHA INICIO", resp)
        if (resp > this.lastDay) {
          this.fechaFinError = true;
        }
        else {
          this.fechaFinError = false;
        }
      });

    this.formulario.get('anio').valueChanges
      .subscribe((resp) => {
        this.formulario.get("fechaInicio").setValue(null);
        this.formulario.get("fechaFin").setValue(null);
      });

    this.formulario.get('mes').valueChanges
      .subscribe((resp) => {
        this.formulario.get("fechaInicio").setValue(null);
        this.formulario.get("fechaFin").setValue(null);
      });

    // this.getTodo();
    this.cargarGridcomponent();
    this.getUnidadesDeNegocio();
    this.getTiposDeVendedores();
    this.cmbMeses = this._catalogo.catalogoMeses();

    this.cmbMeses.unshift({
      valor: 'Seleccione',
      clave: null,
    });

    this.estados.get('estados').setValue(1);
  }

  mostrarDetalle = false;

  unidadDeNegocioChange(tiposDeVendedores = null, vendedor = null) {

    console.log("unidadDeNegocioChange", tiposDeVendedores)

    this.loading = true;
    let unidadesDeNegocio = [];
    var elementos = document.getElementsByName("unidadDeNegocio[]");

    for (var i = 0; i < elementos.length; i++) {
      if (elementos[i]["checked"]) {
        unidadesDeNegocio.push(elementos[i]["value"]);
      }
    }

    this._serviciosCRUD.obtenerTiposDeVendedoresPorUnidadesDeNegocios(unidadesDeNegocio).subscribe((res: any[]) => {
      // console.log("getTodo()", res)
      this.loading = false;

      if (unidadesDeNegocio.length > 0) {
        this.listTiposDeVendedores = res;
        this.listTiposDeVendedores.unshift({
          descripcion: 'TODOS',
          idTipo: 'todos',
        });

        if (tiposDeVendedores) {
          this.formulario.get("tipoVendedorId").setValue(tiposDeVendedores[0]);
          // if (vendedor) {
          //   this.formulario.get("vendedorId").setValue(this.cabecera.vendedorId);
          // }
          // else {
          //   this.formulario.get("vendedorId").setValue('todos');
          // }
        }
      }
      else
        this.listTiposDeVendedores = [];


    }, (err) => {
      this.loading = false;
      this.listTiposDeVendedores = [];
    });

  }

  getTodo() {

    this.listaVacia = true;
    this.loading = true;

    this._serviciosCRUD.filtroEstado('').subscribe((res: any[]) => {
      // console.log("getTodo()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  getUnidadesDeNegocio() {
    this._serviciosCRUD.unidadesDeNegocio().subscribe((res: any[]) => {
      console.log("getTodo()", res)
      this.unidadesDeNegocio = res;
    }, (err) => {
      this.unidadesDeNegocio = [];
    });
  }


  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idLiquidacion',
        filter: true,
        sortable: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Estado Proceso',
        field: 'estadoProceso',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Proceso',
        field: 'fechaProceso',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Mes',
        field: 'mes',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Año',
        field: 'anio',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Total Tipo Vendedor',
        field: 'totalTipoLiquida',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Total Empleado',
        field: 'totalEmplLiquida',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Total ($) Generado',
        field: 'totalPagoLiquida',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Estado Cierre',
        field: 'estadoCierre',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.ver,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

  }

  nuevo() {
    this.isCreate = true;
    this.mostrarDetalle = false;
    this.lsAll = [];
    this.listTiposDeVendedores = [];
    this.lsDetalle = [];
    this.formulario.reset();
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Procesamiento Mensual De Liquidación de Fondo Vehicular';

    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    // console.log("userData", userData)
    this.formulario.get('usuario').setValue(userData.login2);
    this.formulario.get('tipoDeLiquidacion').setValue('VEHICULAR');

    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = (today.getMonth() + 1); // Months start at 0!
    let dd = today.getDate();
    let ddd, mmm;

    if (dd < 10) { ddd = '0' + dd; } else { ddd = dd; }
    if (mm < 10) { mmm = '0' + mm; } else { mmm = mm; }

    const formattedToday = ddd + '/' + mmm + '/' + yyyy;

    this.formulario.get('fechaProceso').setValue(formattedToday);
    this.formulario.get('fechaRevision').setValue(formattedToday);

  }

  cabecera;
  liquidacion;
  isCreate = false;
  estadoCierre = "";
  lsDetalleErrores = [];
  lsDetalleProcesadas = [];
  editar({ rowData }) {

    this.lsDetalleErrores = [];
    this.lsDetalleProcesadas = [];
    this.oneTimeSetSeller = true;

    this.lsAll = [];
    this.loading = true;
    this.isCreate = false;
    // console.log("EDITAR", rowData)
    this.formulario.reset();
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Procesamiento Mensual De Liquidación de Fondo Vehicular';
    this.commonFormService.abrirFormularioParaGuardar(this);

    this._serviciosCRUD.getporId(rowData.idLiquidacion).subscribe((res: any) => {

      this.lsAll = res;
      this.liquidacion = res;
      this.mostrarDetalle = true;
      this.cabecera = res.cabecera;
      res.cabecera.fechaInicio = '';
      res.cabecera.fechaFin = '';
      res.cabecera.tipoLiquidacion = 'VEHICULAR';
      res.cabecera.tipoDeLiquidacion = 'VEHICULAR';
      console.log("editar()", res)
      this.formulario.setValue(res.cabecera);

      // let lsUnidadNegocio = ["E01"];
      let lsUnidadNegocio = res.cabecera.lsUnidadNegocio;
      var elementos = document.getElementsByName("unidadDeNegocio[]");

      if (lsUnidadNegocio) {
        for (var i = 0; i < elementos.length; i++) {
          if (lsUnidadNegocio.indexOf(elementos[i]["value"]) > -1) {
            elementos[i]["checked"] = true;
          }
        }
      }

      // this.unidadDeNegocioChange([27]);
      this.unidadDeNegocioChange(res.cabecera.lsTipoVendedorId, res.cabecera.vendedorId);

      this.estadoCierre = res.cabecera.estadoCierre;

      this.lsDetalle = res.detalle;
      console.log("lsDetalle", this.lsDetalle);
      console.log("lsDetalleErrores", this.lsDetalleErrores);
      console.log("lsDetalleProcesadas", this.lsDetalleProcesadas);

      for (let i = this.lsDetalle.length - 1; i >= 0; i--) {
        console.log("this.lsDetalle[i]", i, this.lsDetalle[i]);
        for (let j = this.lsDetalle[i].listVendedoresLiquidacion.length - 1; j >= 0; j--) {
          console.log("listVendedoresLiquidacion[j]", j, this.lsDetalle[i].listVendedoresLiquidacion[j]);
          if (this.lsDetalle[i].listVendedoresLiquidacion[j].error !== null)
            this.lsDetalleErrores.push(this.lsDetalle[i].listVendedoresLiquidacion[j]);
          if (this.lsDetalle[i].listVendedoresLiquidacion[j].error === null)
            this.lsDetalleProcesadas.push(this.lsDetalle[i].listVendedoresLiquidacion[j]);
        }
      }


      console.log("lsDetalle", this.lsDetalle);
      console.log("lsDetalleErrores", this.lsDetalleErrores);
      console.log("lsDetalleProcesadas", this.lsDetalleProcesadas);

      setTimeout(() => {
        this.listFiltroTabla.get("listTipoFiltroTabla").setValue("");
      }, 1000);

      this.loading = false;
    }, (err) => {
      this.loading = false;
    });

  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarDetalle = false;
    this.lsDetalle = [];
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Procesamiento De Comisiones';
    this.tituloForm = 'Lista De Procesamiento De Comisiones';
  }

  /** SERVICIOS */
  eliminar({ rowData }) {

    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._serviciosCRUD.deleteComision(rowData.idLiquidacion),
      })
      .then((res: any) => {
        this.getTiposDeVendedores();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  guardar() {

    let datos = this.formulario.getRawValue();

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._serviciosCRUD.saveTipoDeVendedore(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getTiposDeVendedores();
    }).catch((err) => {
      // console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizar() {
    // console.log("actualizar")

    // console.log(this.formulario.getRawValue())
    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._serviciosCRUD.updateTipoDeVendedore(this.formulario.getRawValue()),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getTiposDeVendedores();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      // console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  listTiposDeVendedores;
  getTiposDeVendedores() {
    // this.loading = true;
    // this._tipoDeVendedor.getTiposDeVendedoresPorEstado("1").subscribe((res: any[]) => {
    //   // console.log("getTiposDeVendedores()", res)
    //   this.loading = false;
    //   this.listTiposDeVendedores = res;

    //   this.listTiposDeVendedores.unshift({
    //     descripcion: 'TODOS',
    //     idTipo: 'todos',
    //   });

    // }, (err) => {
    //   this.loading = false;
    //   this.listTiposDeVendedores = [];
    //   this.listTiposDeVendedores.unshift({
    //     descripcion: 'TODOS',
    //     idTipo: 'todos',
    //   });
    // });
  }

  getFormValidationErrors() {

    // console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          // console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    // console.log('Number of errors: ', totalErrors);
    // console.log('formulario: ', this.formulario.getRawValue());
  }

  oneTimeSetSeller = false;
  listVendedores;
  vendedores(tipoDeVendedor) {

    this.loading = true;
    this._altaDeVendedor.getVendedorPorEstado(tipoDeVendedor, 1).subscribe((res: any[]) => {
      console.log("getTiposDeVendedores()", res)
      this.loading = false;
      this.listVendedores = res;

      for (let i = 0; i < this.listVendedores.length; i++) {
        this.listVendedores[i].nombreAMostrar = this.listVendedores[i].codigoSap + " - " + this.listVendedores[i].nombreVendedor1;
      }

      this.listVendedores.unshift({
        nombreAMostrar: 'TODOS',
        idVendedor: 'todos',
      });

      if (this.cabecera?.vendedorId) {
        this.formulario.get("vendedorId").setValue(this.cabecera.vendedorId);
        this.formulario.get('nombreVendedor').setValue(this.listVendedores.filter(vendedor => vendedor.idVendedor === this.cabecera.vendedorId)[0].nombreAMostrar);
      }
      else {
        this.formulario.get("vendedorId").setValue('todos');
        this.formulario.get('nombreVendedor').setValue('TODOS');
      }
    }, (err) => {
      this.loading = false;
      this.listVendedores = [];

      this.listVendedores.unshift({
        nombreAMostrar: 'TODOS',
        idVendedor: 'todos',
      });

      this.formulario.get("vendedorId").setValue('todos');

    });

  }

  lsAll = [];
  consultar() {


    this.loading = true;

    let formData;
    if (this.formulario.get("vendedorId").value && this.formulario.get("vendedorId").value != '' && this.formulario.get("vendedorId").value != 'todos') {
      formData = {
        "idLiquidacion": parseInt(this.formulario.get("idLiquidacion").value),
        "anio": parseInt(this.formulario.get("anio").value),
        "mes": parseInt(this.formulario.get("mes").value),
        "mesFin": parseInt(this.formulario.get("mesFin").value),
        "lsTipoVendedorId": [parseInt(this.formulario.get("tipoVendedorId").value)],
        "vendedorId": parseInt(this.formulario.get("vendedorId").value),
        "tipoLiquidacion": "VEHICULAR",
        "usuario": this.formulario.get("usuario").value,
        "estadoProceso": this.formulario.get("estadoProceso").value,
        "estadoCierre": this.formulario.get("estadoCierre").value,
      }
      formData.vendedorId = formData.vendedorId == 'todos' ? null : formData.vendedorId;
    } else {
      formData = {
        "idLiquidacion": parseInt(this.formulario.get("idLiquidacion").value),
        "anio": parseInt(this.formulario.get("anio").value),
        "mes": parseInt(this.formulario.get("mes").value),
        "mesFin": parseInt(this.formulario.get("mesFin").value),
        "lsTipoVendedorId": [parseInt(this.formulario.get("tipoVendedorId").value)],
        "tipoLiquidacion": "VEHICULAR",
        "usuario": this.formulario.get("usuario").value,
        "estadoProceso": this.formulario.get("estadoProceso").value,
        "estadoCierre": this.formulario.get("estadoCierre").value,
      }
    }

    let lsUnidadNegocio = [];
    var elementos = document.getElementsByName("unidadDeNegocio[]");

    for (var i = 0; i < elementos.length; i++) {
      if (elementos[i]["checked"]) {
        lsUnidadNegocio.push(elementos[i]["value"]);
      }
    }

    formData.lsTipoVendedorId = this.formulario.get("tipoVendedorId").value == 'todos' ? null : formData.lsTipoVendedorId;
    // formData.fechaInicio = this.formulario.get("fechaInicio").value;
    // formData.fechaFin = this.formulario.get("fechaFin").value;
    formData.lsUnidadNegocio = lsUnidadNegocio;

    console.log("FORMULARIO formData", formData);

    this._serviciosCRUD.getLiquidacion(formData).subscribe((res: any) => {
      console.log("getLiquidacion()", res)
      this.loading = false;
      this.mostrarDetalle = true;

      res.cabecera.usuario = this.formulario.get('usuario').value;

      this.lsAll = res;
      this.lsDetalle = res.detalle;
      this.liquidacion = res;

      this.formulario.get("estadoProceso").setValue(res.cabecera.estadoProceso);
      this.formulario.get("estadoCierre").setValue(res.cabecera.estadoCierre);
      this.formulario.get("totalTipoLiquida").setValue(res.cabecera.totalTipoLiquida);
      this.formulario.get("totalEmplLiquida").setValue(res.cabecera.totalEmplLiquida);
      this.formulario.get("totalPagoLiquida").setValue(res.cabecera.totalPagoLiquida);

      for (let i = 0; i < this.lsDetalle.length; i++) {
        for (let j = 0; j < this.lsDetalle[i].listVendedoresLiquidacion.length; j++) {
          if (this.lsDetalle[i].listVendedoresLiquidacion[j].error.length > 0) {
            Swal.fire({
              icon: 'warning',
              title: 'Error en los registros.',
              text: "Para revisar los detalles descargue el log de registros.",
            });
            break;
          }
        }
      }

      this.listFiltroTabla.get("listTipoFiltroTabla").setValue("");

      this.loading = false;

    }, (err) => {
      this.loading = false;
      this.lsAll = [];
      this.lsDetalle = [];
    });
  }

  procesar() {
    this.loading = true;
    this._serviciosCRUD.guardarLiquidacion(this.lsAll).subscribe((res: any[]) => {
      // console.log("procesar()", res)

      this.formulario.get('idLiquidacion').setValue(res);

      this.loading = false;
      this.getTodo();

      Swal.fire({
        icon: 'success',
        title: 'Guardado.',
      });

    }, (err) => {
      this.loading = false;
      this.listTiposDeVendedores = [];
    });
  }

  descargarLogs() {
    let data: any = [];
    let cabecera: any[] = [['Tipo', 'Variable Asignada', 'Sueldo Base', 'Peso %', 'Valor Variable', 'Vendedor', '% Cumplimiento', '% Ganancia', 'Comisión', 'Error']];

    for (let i = 0; i < this.lsDetalle.length; i++) {
      for (let j = 0; j < this.lsDetalle[i].listVendedoresLiquidacion.length; j++) {

        let error = "";
        let item = this.lsDetalle[i].listVendedoresLiquidacion[j];

        if (item.error) {
          for (let k = 0; k < item.error.length; k++)
            error = error + item.error[k] + " ";
        }

        if (item.error !== null) {
          data.push(
            {
              nombreTipoVendedor: (item.nombreTipoVendedor === undefined) ? '' : item.nombreTipoVendedor,
              nombreVariable: (item.nombreVariable === undefined) ? '' : item.nombreVariable,
              sueldoVariable: item.sueldoExcepcion > 0 ? item.sueldoExcepcion : item.sueldoVariable,
              variablePeso: (item.variablePeso === undefined) ? '' : item.variablePeso,
              valorPeso: (item.valorPeso === undefined) ? '' : item.valorPeso,
              nombreVendedor: (item.nombreVendedor === undefined) ? '' : item.nombreVendedor,
              cumplimiento: (item.cumplimiento === undefined) ? '' : item.cumplimiento,
              ganancia: (item.ganancia === undefined) ? '' : item.ganancia,
              valorComision: (item.valorComision === undefined) ? '' : item.valorComision,
              error: (error === undefined) ? '' : error,
            }
          );
        }
      }
    }

    let name: string = "Log.csv";
    this._utils.exportCSV(cabecera, data, name);
  }

  descargarReporte() {
    let data: any = [];

    for (let i = 0; i < this.lsDetalle.length; i++) {

      data.push(
        {
          nombreTipoVendedor: 'Tipo',
          nombreVariable: 'Variable Asignada',
          sueldoVariable: 'Sueldo Base',
          variablePeso: 'Peso %',
          valorPeso: 'Valor Variable',
          nombreVendedor: 'Vendedor',
          cumplimiento: '% Cumplimiento',
          ganancia: '% Ganancia',
          valorComision: 'Comisión',
          error: 'Error',
        }
      );

      for (let j = 0; j < this.lsDetalle[i].listVendedoresLiquidacion.length; j++) {

        let item = this.lsDetalle[i].listVendedoresLiquidacion[j];

        data.push(
          {
            nombreTipoVendedor: (item.nombreTipoVendedor === undefined) ? '' : item.nombreTipoVendedor,
            nombreVariable: (item.nombreVariable === undefined) ? '' : item.nombreVariable,
            sueldoVariable: item.sueldoExcepcion > 0 ? item.sueldoExcepcion : item.sueldoVariable,
            variablePeso: (item.variablePeso === undefined) ? '' : item.variablePeso,
            valorPeso: (item.valorPeso === undefined) ? '' : item.valorPeso,
            nombreVendedor: (item.nombreVendedor === undefined) ? '' : item.nombreVendedor,
            cumplimiento: (item.cumplimiento === undefined) ? '' : item.cumplimiento,
            ganancia: (item.ganancia === undefined) ? '' : item.ganancia,
            valorComision: (item.valorComision === undefined) ? '' : item.valorComision,
            error: (item.error === undefined || item.error === null) ? '' : item.error[0],
          }
        );
      }

      data.push(
        {
          nombreTipoVendedor: '',
          nombreVariable: '',
          sueldoVariable: '',
          variablePeso: '',
          valorPeso: '',
          nombreVendedor: '',
          cumplimiento: '',
          ganancia: 'TOTAL:',
          valorComision: this.lsDetalle[i].comision,
          error: '',
        }
      );

      data.push(
        {
          nombreTipoVendedor: '',
          nombreVariable: '',
          sueldoVariable: '',
          variablePeso: '',
          valorPeso: '',
          nombreVendedor: '',
          cumplimiento: '',
          ganancia: '',
          valorComision: '',
          error: '',
        }
      );
    }

    let name: string = "Reporte.csv";
    this._utils.exportCSV([], data, name);
  }

  cerrar() {
    this.loading = true;

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._serviciosCRUD.cerrarLiquidacion(this.formulario.get('idLiquidacion').value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.loading = false;

      Swal.fire({
        icon: 'success',
        title: 'Cerrado.',
      });

      this.getTodo();

    }).catch((err) => {
      // console.log(err);
      this.loading = false;
    });

  }

}
